// extracted by mini-css-extract-plugin
export default {"deletebutton":"FilledList_deletebutton__KlT8s"};